<template lang="pug">
.container.grid-lg
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      form-filter(@submit="fetchReport" initializePeriodo)
  .full-height.loading.loading-lg(v-if="loading")
  div(v-else-if="report")
    div(v-if="showReport")
      card-group-data(
        :report="report",
        label-items="Meses",
        label-total="Total de todos fiscais"
      )
    .card.mt-2(v-else)
      .card-body
        .empty
          .empty-icon
            i.fa.fa-search.fa-4x
          p.empty-title.h5 Nada encontrado
          p.empty-subtitle Não foram encontradas documentos neste período
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import docs from "@/api/indicadores/docs"
import FormFilter from "./components/Filter"
import CardGroupData from "./components/CardGroupData"

export default {
  data() {
    return {
      loading: false,
      report: null,
    }
  },
  components: { FormFilter, CardGroupData },
  computed: {
    showReport() {
      return this.report.data && Object.values(this.report.data).length
    },
  },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await docs.fiscaisPorMeses({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
